<template>
  <div :class="classes" data-testid="home-illustration">
    <div
      v-if="isThemeWarrenManaged"
      data-testid="home-illustration-dynamic"
      class="home-illustration__dynamic"
    >
      <div class="home-illustration__dynamic--prefetch" />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { isThemeWarrenManaged } from '@/modules/common/services/theme';

@Component
export default class HomeIllustration extends Vue {
  hasError = false;
  hasLoaded = false;

  get classes() {
    return [
      'home-illustration',
      {
        'home-illustration--partner': this.isThemeWarrenManaged,
        'home-illustration--loaded': this.hasLoaded
      }
    ];
  }

  handleLoad() {
    this.hasError = false;
    this.hasLoaded = true;
  }

  handleError() {
    this.hasError = true;
  }

  private get isThemeWarrenManaged() {
    return isThemeWarrenManaged();
  }
}
</script>

<style lang="less" scoped>
@custom-overlay: #0000003b;
@keyframes dynamic-hero-full {
  0%,
  100% {
    background: url('@/assets/imgs/hero/gradients/g1.jpg');
  }
  25% {
    background: url('@/assets/imgs/hero/gradients/g2.jpg');
  }
  50% {
    background: url('@/assets/imgs/hero/gradients/g3.jpg');
  }
  75% {
    background: url('@/assets/imgs/hero/gradients/g4.jpg');
  }
}

.home-illustration {
  position: relative;
  display: inline-flex;
  height: 78vh;
  width: 100%;
  background: @brand-primary;
  z-index: 0;

  > picture {
    width: 100%;
    z-index: -1;
    transition: opacity 0.5s ease;
    opacity: 0;

    > img {
      object-fit: cover;
    }
  }

  &::before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    background: @custom-overlay;
  }

  &--partner::before {
    background: transparent;
  }

  &--loaded > picture {
    opacity: 1;
  }

  &__dynamic {
    width: 100%;
    height: 100%;
    background-size: 100% 78vh !important;
    animation: dynamic-hero-full 60s infinite linear;

    &--prefetch {
      width: 0;
      height: 0;
      visibility: hidden;
      animation: dynamic-hero-full 1s linear;
    }
  }
}
</style>
